/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { availableLangs } from '../exports';

const loader = availableLangs.reduce((acc, lang) => {
  acc[lang] = () => import(`./locale/${lang}.json`);
  return acc;
}, {});

// Provides sharePanel translations for a module, or a component.
export const BulbSharePanelTranslationProvider = {
  provide: TRANSLOCO_SCOPE,
  useValue: {
    scope: 'sharePanel',
    loader,
  },
};
